import React from 'react';
import { string, func } from 'prop-types';

import Icon from 'components/icon';

const ActiveFilter = ({ clearFilterTitle, onClearClick, title }) => (
    <button
        className="listing-active-filters__button"
        onClick={onClearClick}
        title={clearFilterTitle}
        type="button"
    >
        <span className="listing-active-filters__button-label">{title}</span>
        <Icon glyph="cross" />
    </button>
);

ActiveFilter.propTypes = {
    clearFilterTitle: string.isRequired,
    title: string.isRequired,
    onClearClick: func.isRequired
};

export default ActiveFilter;
